import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';

// WEB-2: админ-вкладки (Wi-Fi точки, Код регистрации) видны только role=admin.
// Скрытие — UX, не защита: маршруты дополнительно гейтит RequireRole, а сервер
// авторизует по роли из БД.
// QR-1b: вкладка «Мой QR» — только при msgInvites из /me (флаг сервера
// MESSENGER_V2 && MSG_INVITES_ENABLED); сама страница гейтится тем же флагом.
const SettingsNav = ({ activeLink, setActiveLink }) => {
  const { isAdmin, msgInvites } = useAuth();
  return (
    <div className='settings-Nav'>
      {msgInvites && (
        <Link to='/msg/invite' className={`nav-button  ${activeLink === 'invite' ? 'active' : ''}`} onClick={() => setActiveLink('invite')}>Мой QR</Link>
      )}
      {isAdmin && (
        <Link to='/settings/wifi' className={`nav-button  ${activeLink === 'wifi' ? 'active' : ''}`} onClick={() => setActiveLink('wifi')}>Wi-Fi точки</Link>
      )}
      {isAdmin && (
        <Link to='/settings/generate-code' className={`nav-button  ${activeLink === 'generate-code' ? 'active' : ''}`} onClick={() => setActiveLink('generate-code')}>Код регистрации</Link>
      )}
      <Link to='/settings/theme' className={`nav-button  ${activeLink === 'theme' ? 'active' : ''}`} onClick={() => setActiveLink('theme')}>Оформление</Link>
      <Link to='/settings/profile' className={`nav-button  ${activeLink === 'profile' ? 'active' : ''}`} onClick={() => setActiveLink('profile')}>Профиль</Link>
    </div>
  );
};

export default SettingsNav;
